import { z } from 'zod';

import { parseOrThrow } from '../../api';
import type { ScreenRules } from '../types';

const count = z.number().int().positive();

export const screenRulesSchema = z.object({
  codeLength: count,
  passwordMinLength: count,
  reasonMinLength: count,
});

export const parseScreenRules = (raw: unknown): ScreenRules => parseOrThrow(screenRulesSchema, raw, 'rules');
